<svg
  width="18"
  height="6"
  viewBox="0 0 18 6"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M0.625 5.9375V5.0625H17.375V5.9375H0.625ZM0.625 0.9375V0.0625H17.375V0.9375H0.625Z"
    fill="white"
  />
</svg>
